import * as style from './InfoButton.css';
import icon from './assets/info-icon.svg';

interface IInfoButtonProps {
  onClick?(): void;
}

export const InfoButton = ({ onClick }: IInfoButtonProps) => {
  return (
    <button className={style['info-button']} type="button" aria-label="Информация о рейтинге" onClick={onClick}>
      <img src={icon} alt="" />
    </button>
  );
};
